import { Tabs } from 'antd'
import { ScreenHeader } from 'components'
import { DeletedVideosList, FlaggedVideosList, VideosList } from 'page-components'
import React, { useState, useMemo } from 'react'
import { VideosTabScreen } from 'utility'
import { HeaderWrapper } from './dashboard'

export const VideosScreen = () => {
  const [tab, setTab] = useState(VideosTabScreen.All)

  const items = useMemo(
    () => [
      {
        key: VideosTabScreen.All,
        label: 'All',
        children: <VideosList />,
      },
      {
        key: VideosTabScreen.Reported,
        label: 'Reported',
        children: <FlaggedVideosList />,
      },
      {
        key: VideosTabScreen.Deleted,
        label: 'Deleted',
        children: <DeletedVideosList />,
      },
    ],
    [],
  )

  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="Videos" />
      </HeaderWrapper>
      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={tab}
            items={items}
            className="custom-tabs"
            centered
            onChange={key => setTab(key)}
          />
        </div>
      </div>
    </div>
  )
}
